function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-426 -1280)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-661 -4073)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 28,
  transform: "translate(1087 5357)",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.646,6.978H23.155v11.2H6.977v2.489a1.247,1.247,0,0,0,1.246,1.245H21.909l4.979,4.978V8.222a1.244,1.244,0,0,0-1.244-1.245M19.423,2H3.245A1.245,1.245,0,0,0,2,3.245V20.666l4.977-4.978H19.423a1.245,1.245,0,0,0,1.244-1.245V3.245A1.245,1.245,0,0,0,19.423,2",
  transform: "translate(1086.555 5356.555)",
  fill: "#1fc5db",
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("path", {
  d: "M0,0H36V36H0Z",
  transform: "translate(426 1280)",
  fill: "none"
}));

var SvgVtr36Px = function SvgVtr36Px(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVtr36Px, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/VTR_36px.59f949c6.svg";
export { ForwardRef as ReactComponent };